import createFormReducer ,{getFormInitialState} from "../../../../../../../../redux/actions-reducers/form/create-form-reducer";


export const FORM_TUTORIA_NAME = 'formTutoria'

const initialState = {
    ...getFormInitialState(),
    valid:false ,
    values: {
       message: '',
    }
}


export function validate({
                             message
                         }) {

    const errorMessages = {}


    return errorMessages
}



export const formTutoriaReducer = createFormReducer(FORM_TUTORIA_NAME, validate, initialState)


// WEBPACK FOOTER //
// ./src/_pages/Account/_pages/CourseList/_pages/Course/_partials/Tutoria/form-reducer.js